import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PairingRule_LongestTime_instance;
var PairingRule_PreferDifferentBadge_instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      d2d(value) {
        switch (value) {
          case 1:
            return PairingRule_LongestTime_getInstance();
          case 2:
            return PairingRule_PreferDifferentBadge_getInstance();
          default:
            return PairingRule_LongestTime_getInstance();
        }
      }
      e2d(rule) {
        var tmp;
        switch (rule.b2_1) {
          case 0:
            tmp = 1;
            break;
          case 1:
            tmp = 2;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var PairingRule_entriesInitialized;
function PairingRule_initEntries() {
  if (PairingRule_entriesInitialized)
    return Unit_instance;
  PairingRule_entriesInitialized = true;
  PairingRule_LongestTime_instance = new (PairingRule())('LongestTime', 0);
  PairingRule_PreferDifferentBadge_instance = new (PairingRule())('PreferDifferentBadge', 1);
}
var PairingRuleClass;
function PairingRule() {
  if (PairingRuleClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'PairingRule');
    PairingRuleClass = $;
  }
  return PairingRuleClass;
}
function PairingRule_LongestTime_getInstance() {
  PairingRule_initEntries();
  return PairingRule_LongestTime_instance;
}
function PairingRule_PreferDifferentBadge_getInstance() {
  PairingRule_initEntries();
  return PairingRule_PreferDifferentBadge_instance;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  PairingRule_LongestTime_getInstance as PairingRule_LongestTime_getInstance2mz3cf30ufjjd,
  PairingRule_PreferDifferentBadge_getInstance as PairingRule_PreferDifferentBadge_getInstance25xp78sq9fx81,
  Companion_instance as Companion_instancen08xrtenlogm,
};
//endregion

//# sourceMappingURL=PairingRule.mjs.map
